const bankTransactionSchema = {
    eventType: "bankTransaction",
    required: ["type", "amount"],
    optional: ["new_balance", "user_agent", "timestamp"],
    validate: (data) => {
      if(!data || typeof data !== "object"){
        throw new Error("Link must be a non-empty object")
      }
      if (!data.type != null && typeof data.type !== "string") {
        throw new Error("bank transaction type must be a string or null/undefined");
    }
    if (!data.amount || typeof data.amount !== "number") {
          throw new Error("bank transaction amount must be a number");
    }
      return true;
    },
    createEventData: (data, additionalData = {}) => {
        console.log("additional data: ", additionalData);
      return {
        type: data.type,
        amount: data.amount,
        user_agent: navigator.userAgent || null,
        timestamp: new Date().toISOString(),
        page_url: window.location.href,
        ...additionalData,
      };
    },
  };
  
  module.exports = bankTransactionSchema;